import { curry } from "ramda"
import { isString, isset } from "../../validate"

const isNumber = ({ value: str }) => {
  if (!isString(str)) return false

  const hasNoOtherCharactor = /^[\d]*$/.test(str)
  if (!hasNoOtherCharactor) return false

  return true
}

export const isFieldNumber = curry((maxLength, { value: fieldValue }) => {
  if (!isset(fieldValue)) return false

  if (maxLength && (fieldValue.length <= 0 || fieldValue.length > maxLength)) return false

  return isNumber({ value: fieldValue })
})

export default isNumber
